/**
 * key=value& 字符串转化成 Object
 * @param {[type]} search key=value&字符串
 */
export function URLSearch2Params(search = window.location.search) {
  const values = search.split('?');
  if (values && values.length && values[1]) {
    return values[1].split('&').reduce((params, keyValue) => {
      return Object.assign(params, {
        [keyValue.split('=')[0]]: keyValue.split('=')[1] || '',
      });
    }, {});
  }
  return {};
}
/**
 * 获取系统信息
 * @returns {string}
 */
export function getOSInfo() {
  const { userAgent } = navigator;
  if (/win/i.test(userAgent)) return 'window';
  if (/mac/i.test(userAgent)) return 'mac';
  if (/Android/i.test(userAgent)) return 'android';
  if (/iphone|ipad|ipod|ios/i.test(userAgent)) return 'ios';
}

export function iSetInterval(fn, wait, options = { immediate: true }) {
  let timer = null;

  function inside() {
    clearTimeout(timer);
    fn();
    timer = setTimeout(inside, wait);
  }

  if (options?.immediate) fn();
  timer = setTimeout(inside, wait);
  return {
    clear() {
      clearTimeout(timer);
    },
    timer,
  };
}
export function cached(fn) {
  const cache = Object.create(null);
  return function cachedFn(str, ...ext) {
    const hit = cache[str];
    return hit || (cache[str] = fn(str, ...ext));
  };
}

/**
 * 解析json字符串
 * @param string
 * @returns {string}
 */
export const jsonParse = (string) => {
  let str = {};
  try {
    str = JSON.parse(string);
  } catch (e) {
    // console.warn();
  }
  return str;
};

/**
 * 路由匹配
 *   精确匹配
 *   包含匹配
 * @param path
 * @param routesMap
 *
 * @param isOnlyExactMatch boolean 开启仅精确匹配模式(新增)
 * @returns {*}
 */
export const matchRoute = (path, routesMap, isOnlyExactMatch) => {
  // 精确匹配
  if (routesMap[path]) {
    return routesMap[path];
  }
  // 完全匹配，没有匹配到，返回null
  if (isOnlyExactMatch) return '';
  // 包含匹配
  let tempI = '';
  for (let i in routesMap) {
    if (routesMap.hasOwnProperty(i)) {
      // 过滤 *
      if (i.includes('*')) continue;
      const reg = new RegExp(`^${i}`);
      if (reg.test(path)) {
        // 匹配到的路由长度
        let iLen = i.length;
        // 当前路径长度
        let pLen = path.length;
        // 最后一个/后面的字符长度
        let lenLast = path.split('/').pop().length;
        // 保存最长匹配的路由
        if (i.length > tempI.length) tempI = i;
        // 匹配到最优解，当差为最后一级path时，为最优解。否则继续匹配
        if (pLen - iLen <= lenLast + 1) {
          return routesMap[i];
        }
      }
    }
  }
  // 没有匹配最优解，返回当前匹配的最长path
  return tempI && routesMap[tempI];
};

/**
 * 格式化CascaderPanel值
 * @params {}
 * @returns { ..., label, value }
 */
export function transformToPanelData(data) {
  return data.map((item) => {
    if (!item?.children?.length) {
      delete item.children;
      return {
        ...item,
        label: item?.meta?.title,
        value: item,
      };
    }
    return {
      ...item,
      label: item?.meta?.title,
      value: item,
      children: transformToPanelData(item.children),
    };
  });
}
